<template>
    <div class="flex flex-col gap-6">
        <h2 class="text-2xl md:text-4xl font-semibold mb-6">
            Notable Diagnostic Test Results (Pre- and Post-Transplant): <br />Imaging and Biochemical Tests
        </h2>

        <div class="flex flex-col md:flex-row gap-6">
            <div class="p-6 bg-lightblue50 flex-1">
                <h5 class="text-2xl font-semibold">CT scan results</h5>
                <ul class="list-disc pl-4  font-light">
                    <li>
                        A CT image of the kidneys showed the patient had <span class="font-semibold">bilateral nephrocalcinosis</span> before transplantation
                    </li>
                </ul>
                <img
                    src="@/assets/img/graphics/transplant/ct-scan.png"
                    alt="CT Scan"
                    class="block object-contain w-full mt-6"
                />
            </div>

            <div class="p-6 bg-gold50 flex-1">
                <h5 class="text-2xl font-semibold">Biochemical test results</h5>
                <p class=" font-light my-3 italic">Pre-transplant</p>
                <ul class="list-disc pl-4  font-light mb-4">
                    <li>
                        Pre-operative SCr was 1296.00 μmol/L and BUN was 20.90 mmol/L
                    </li>
                </ul>

                <p class=" font-light my-3 italic">Post-transplant</p>
                <ul class="list-disc pl-4  font-light">
                    <li>
                        After allograft, routine blood biochemical analysis and therapeutic drug monitoring follow-up tests were regularly conducted
                    </li>
                    <li>
                        The kidney graft gradually developed  DGF with SCr 674.00 μmol/L and <br />BUN 46.34 mmol/L
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
